module.exports = __webpack_public_path__ + "static/img/feature_1.ee8c1b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fundamentals/feature_1.png
// module id = 57oY
// module chunks = 0